export function TextAiStarIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" fill="none" />
      <path
        d="M16.1024 6.19962L16.8293 4H18.0924L18.8193 6.19962L21 6.93283V8.20693L18.8193 8.94013L18.0924 11.1398H16.8293L16.1024 8.94013L13.9217 8.20693V6.93283L16.1024 6.19962Z"
        fill="currentColor"
      />
      <path d="M18.5704 13.1658V21H16.3513V13.1658H18.5704Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.73959 6.4507H10.4293L14.1687 21H11.8763L11.0133 17.6425H6.15545L5.29246 21H3L6.73959 6.4507ZM6.73077 15.4041H10.438L8.71211 8.68906H8.45673L6.73077 15.4041Z"
        fill="currentColor"
      />
    </svg>
  );
}
